<template>
  <div style="width: 100%;">
    <div class="table-wrapper" ref="tableWrapper">
      <table class="table is-striped is-fullwidth ws-nowrap" ref="table">
        <thead>
          <th>{{ $t("form.id") }}</th>
          <th>{{ $t("form.min_width") }}</th>
          <th>{{ $t("form.max_width") }}</th>
          <th>{{ $t("form.min_height") }}</th>
          <th>{{ $t("form.max_height") }}</th>
          <th>{{ $t("form.thickness") }}</th>
          <th></th>
        </thead>
        <tbody>
          <industry-glass-size v-for="size in active.glass_sizes" :key="size.id" :size="size" />
        </tbody>
      </table>
    </div>
    <span
      v-if="showSwipeIcon"
      class="mdi mdi-gesture-swipe-horizontal has-text-primary"
      style="font-size: 25px"
    ></span>

    <nuxt-link
      class="button is-link is-pulled-right m-t-5"
      :to="localePath('office-industries-id-glass-sizes-create')"
    >{{ $t("form.create") }}</nuxt-link>
  </div>
</template>

<script>
import IndustryGlassSize from "@/components/Industry/GlassSize";

export default {
  components: {
    IndustryGlassSize
  },

  validate({ store, params }) {
    const industry = store.state.industries.list.find(e => e.id == params.id);
    return industry && industry.type == "glass";
  },

  computed: {
    active() {
      return this.$store.state.industries.active;
    },

    showSwipeIcon() {
      return (
        this.isMounted &&
        this.$refs.table &&
        this.$refs.table.scrollWidth > this.$refs.tableWrapper.clientWidth
      );
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/nuxt/pages/office/industries/_id/glass-sizes/index.vue